import type { ComparisonServiceField } from '@/features/Comparison/Components/types';
import {
  ClientResourceContainer,
  Role,
  RoleLabel,
  useClientStore,
} from '@/features/Clients';
import { FIELD_PATH_CONTEXT } from '@/features/Comparison/utils';
import { computed } from 'vue';
import { getRelevantVPRoles } from '@/utils/getCurrentSpartenConfig/getCurrentSpartenConfig';
import { getEntries } from '@/utils/objects/objects';

export const generateUnfFieldPathCallback: (
  path: string,
  tariffOverridePath?: string,
) => ComparisonServiceField['fieldPath'] = (path, tariffOverridePath) => {
  return (context: FIELD_PATH_CONTEXT, role?: Role) => {
    if (context === FIELD_PATH_CONTEXT.INPUT) {
      return `${role}.${path}`;
    }

    return `personenDetails.${role}.${tariffOverridePath ?? path}`;
  };
};

export const availableRoles = computed(() => {
  const result: Partial<Record<Role, boolean>> = {};

  getRelevantVPRoles().forEach((role) => {
    result[role] = useClientStore().hasClientWithRole(role);
  });

  return result;
});

export const usedRoles = computed(() => {
  const roles: Role[] = [];

  getEntries(availableRoles.value).forEach(([role, isInUse]) => {
    if (isInUse === true) {
      roles.push(role);
    }
  });

  return roles;
});

export const vpNameForRole = computed(
  () => (role: Role, client?: ClientResourceContainer['data']) => {
    const nameParts = [client?.vorname ?? '', client?.nachname ?? ''];

    return nameParts.join(' ').trim() || RoleLabel[role];
  },
);
